import { ReactComponent as TrashIcon } from '../../../assets/icons/icon-trash.svg'
import css from './trashButton.module.css'

interface IProps {
  onClick?: () => void
}
const TrashButton = (props: IProps) => {
  return <TrashIcon onClick={props.onClick} className={css.icon} />
}

export default TrashButton
